import { gql } from '@apollo/client';

export const MA_TRANSACTIONS_FILTERS_SUMMARY_QUERY = gql`
  query maTransactionsSummary {
    maTransactionsSummary {
      startYear
      endYear
      minValuation
      maxValuation
      minReserves
      maxReserves
      minProduction
      maxProduction
      minEmissions
      maxEmissions
      minAcquisitionCostOutliers
      maxAcquisitionCostOutliers
      minPriceFlowingBarrelOutliers
      maxPriceFlowingBarrelOutliers
    }
  }
`;
